(function(){
  'use strict';

  AOS.init({
    once: true,
    duration: 900,
    offset: 120
  });

})();

document.addEventListener('quickview:open', function() {
  AOS.init({
    once: true,
    duration: 900,
    offset: 120
  });
});

document.addEventListener('quickview:loaded', function() {
  AOS.init({
    once: true,
    duration: 900,
    offset: 120
  });
});
//there's also Liquid code in /snippets/header-icons.liquid to set the initial cart count

document.addEventListener("cart:updated", function(evt) {
  const cartCount = evt.detail.cart.item_count;
  updateCartCount(cartCount);
});

document.addEventListener("ajaxProduct:added", function(evt) {
  theme.cart.getCart().then(cart => {
   updateCartCount(cart.item_count);
  });
});

function updateCartCount(cartCount) {
  const fallbackTextEl = document.querySelector(".site-nav__link--icon .cart-link .icon__fallback-text");
  if (fallbackTextEl) {
    fallbackTextEl.textContent = `Bag (${cartCount})`;
  }
}
function moveFooterSocial() {
  const footerSocial = document.querySelector(".footer__social");
  const menu1LinkList = document.querySelector(".footer__item--menu-1 .site-footer__linklist");

  if (window.innerWidth < 700 && footerSocial && menu1LinkList) {
    menu1LinkList.appendChild(footerSocial);
  }
}

document.addEventListener("DOMContentLoaded", moveFooterSocial);
window.addEventListener("resize", moveFooterSocial);

document.addEventListener("page:loaded", function() {
  const target = document.querySelector(".note--success");
  if (target) {
    const rect = target.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect.top + scrollTop - 100; // 100px above

    window.scrollTo({
      top: offset
    });
  }
});

document.addEventListener("DOMContentLoaded", function() {
  var parents = document.querySelectorAll(".template-product .shopify-section .shopify-section");
  
  parents.forEach(function(parent) {
    if (parent.querySelector('[id*="review_widget"]')) {
      parent.classList.add("reviews-section");
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll("a[href*='substack']");

  links.forEach(link => {
    if (!link.hasAttribute("target")) {
      link.setAttribute("target", "_blank");
    }
  });
});
